import type {
  GeneratedMutation,
  GeneratedQuery,
} from "@aws-amplify/api-graphql";
import gql from "graphql-tag";
import {
  DEFAULT_LOCALE,
  LOCALES,
  type ClientUser,
  type Locale,
  type UpdateClientUserInput,
} from "@rmh/defs";

export const UPDATE_PREFERRED_LANGUAGE_MUTATION_KEY = [
  "updatePreferredLanguage",
];

export const preferredLanguageQueryKey = (sub?: string): unknown[] => [
  "preferredLanguage",
  sub,
];

const isLocale = (code?: string | null): code is Locale =>
  (LOCALES as readonly (string | null | undefined)[]).includes(code);

export const toDisplayLocale = (code?: string | null): Locale =>
  isLocale(code) ? code : DEFAULT_LOCALE;

export const getPreferredLanguageQuery = gql`
  query GetPreferredLanguage($id: ID!) {
    getClientUser(id: $id) {
      preferredLanguage
    }
  }
`.loc?.source.body as GeneratedQuery<
  { id: string },
  { getClientUser: Pick<ClientUser, "preferredLanguage"> }
>;

export const updatePreferredLanguageMutation = gql`
  mutation UpdatePreferredLanguage($input: UpdateClientUserInput!) {
    updateClientUser(input: $input) {
      id
    }
  }
`.loc?.source.body as GeneratedMutation<
  { input: UpdateClientUserInput },
  { updateClientUser: Pick<ClientUser, "id"> }
>;
